import type { FaireProductEntity } from "../../entity_types/product";

export const p_un9r5utccs: FaireProductEntity = {
  token: "p_un9r5utccs",
  type: "product",
  name: "Missing You Mushroom Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2b656c9bf2b282d25a162c2b9763d259278b00ef4b5ed4a1307e76aaeaa9735b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67ed46efd123c877cb5c0aa24d1bac8e36979a75e6156f0b70185b24ab704a61.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Those days when you miss your friend so much, you just hang from your mushroom, dreaming idly of seeing them again. Best thing to do - send this card.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:59.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
